type WithValue<T> = { value: T };

export interface IncivilityValue {
  block_all: number;
  publish_and_moderate: number;
  require_approval: number;
}

export type Thresholds = [number, number, number, number] | [number];

type TextAnalyzerSettingsValue = Record<string, Thresholds | undefined>;

type ModelConfigResponseValue = { name: string; ds_model?: string; hidden: boolean };

export interface ModerationFiltersConfigsResponse {
  tenant: {
    moderation: {
      openweb_incivility_thresholds: WithValue<IncivilityValue>;
      openweb_incivility_tagger_enabled: WithValue<boolean>;
      text_analyzer_settings: WithValue<TextAnalyzerSettingsValue>;
      models_config: WithValue<Record<string, ModelConfigResponseValue>>;
      suspected_bot_tagger_threshold: WithValue<number>;
      suspected_bot_tagger_enabled: WithValue<boolean>;
      username_text_analyzer_settings: WithValue<TextAnalyzerSettingsValue>;
    };
  };
}

export type ModelConfigs = Record<string, ModelConfig>;
export type ModelConfigsEditable = Record<string, ModelConfigEditable>;

export type ModelConfigValue = MultipleThresholds | SingleThreshold | null;
export type ModelConfigsValues = Record<string, ModelConfigValue>;

export interface ModelConfig {
  label: string;
  value: ModelConfigValue;
}

export interface ModelConfigEditable extends ModelConfig {
  selected: boolean;
}

export interface MultipleThresholds {
  type: 'multiple';
  reject: number;
  requireApproval: number;
  publishAndModerate: number;
}

export interface SingleThreshold {
  type: 'single';
  threshold: number;
}

export interface ModerationFiltersState {
  isFetched: boolean;
  models: ModelConfigs;
  dataScienceModelMap: DataScienceModelMap;
}

export enum ModerationModel {
  Incivility = 'incivility'
}

export interface SaveModerationFiltersPayload {
  spotId: string;
  configs: ModelConfigsValues;
  onResult?: (success: boolean) => void;
}

export type TenantConfigValue = { key: string; value: any };
export type TenantConfigs = Array<TenantConfigValue>;

export type DataScienceModelMap = Record<string, string>;
